module.exports = __webpack_public_path__ + "static/media/seal.2bf06a2d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/common/img/seals/SOS/seal.svg
// module id = 1028
// module chunks = 0